import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import i18n from "src/shared/services/languages/i18n";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";

export default function calculateColumnsPerTab(tab: Number) {
  const { t } = useTranslation();

  const activeOwnColumns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: t("Αριθμός υπόθεσης"),
        accessorKey: "case_id",
        accessorFn: (originalRow) => {
          return (
            <Link
              to={`${"/chamber/manageAadeCaseApplication"}/${originalRow.case_id}`}
            >
              {originalRow.case_id}
            </Link>
          );
        },
      },
      {
        header: t("Αριθμός Γ.Ε.ΜΗ."),
        accessorKey: "company_id",
      },
      {
        header: t("ΑΦΜ"),
        accessorKey: "afm",
      },
      {
        header: t("Νομική Μορφή"),
        accessorKey: "legalType",
      },
      {
        header: t("Πλήθος αναντιστοιχιών"),
        accessorKey: "subcase_count",
      },
      ...(tab === 0
        ? []
        : [
            {
              header: t("Αρμόδιος Χρήστης"),
              accessorKey: "responsible_user",
            },
          ]),
      {
        header: t("Ημερομηνία Δημιουργίας"),
        accessorKey: "date_created",
        accessorFn: (originalRow) => {
          return (
            <>
              {format(
                parseISO(originalRow.date_created),
                "dd/MM/yyyy HH:mm:ss",
              )}
            </>
          );
        },
      },
    ],
    [i18n.language, tab],
  );

  return activeOwnColumns;
}
